<template>
  <div class="no-result">
    <div class="title">ไม่พบร้านอาหารของคุณ</div>
    <ul>
      <li>ตรวจสอบการสะกดชื่อร้านให้ถูกต้อง</li>
      <li>ร้านของคุณอาจไม่มีข้อมูลในระบบ หรืออยู่นอกเขตบริการของ LINE MAN (กรุงเทพฯ, ปริมณฑล และพัทยา) หากต้องการเป็นพาร์ทเนอร์กับเรา สมัครได้ที่ด้านล่าง </li>
    </ul>
    <div class="button-flex">
      <a 
        target="_blank" 
        href="https://www.wongnai.com/delivery/business/signup?utm_source=lineman-sellers"
        rel="noopener noreferrer"
        v-on:click="trackAnalytics('link', 'registerRestaurant', 'searchResult-notFound')"
      >
        <div class="button">สมัครเข้าระบบ LINE MAN</div>
      </a>
    </div>
  </div>
</template>

<script>
  export default {
    methods: {
      trackAnalytics(category, action, label) {
        window.gtag('event', action, {
          event_category: category,
          event_label: label
        });
      }
    }
  }
</script>

<style lang="scss" scoped>
  .no-result {
    border-top: 1px solid rgba(0, 0, 0, 0.2);
    flex: 1;
    padding: 24px;
    overflow-y: auto;
    height: 100%;
    min-height: 265px;
  }
  .button-flex {
    display: flex;
  }
  .title {
    font-size: 24px;
    font-weight: 700;
  }
  ul {
    margin-bottom: 32px;
  }
  @media screen and (max-width: 720px) {
    .no-result {
      border-top: none;
      padding: 24px;
    }
    .button {
      width: 100%;
      min-height: 50px;
    }
  }
</style>